import { cva } from 'class-variance-authority';

/**
 * Platform admin is an instrument, not a storefront: the default control is
 * 36px, not the 44px the venue-facing apps use, because nobody drives this
 * console with a thumb across a counter. `lg` keeps the 56px staff target for
 * any surface that is shared with the tablet apps.
 *
 * Only `default` carries brand colour. Secondary, outline and ghost are warm
 * neutrals, so a screen with eight buttons on it still has exactly one that
 * looks like the thing to press.
 */
export const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ring)] focus-visible:ring-offset-1 focus-visible:ring-offset-[var(--background)] disabled:pointer-events-none disabled:opacity-50',
  {
    variants: {
      variant: {
        default:
          'bg-[var(--primary)] text-[var(--primary-foreground)] hover:brightness-110',
        secondary:
          'bg-[var(--muted)] text-[var(--foreground)] hover:bg-[var(--surface-hover)]',
        outline:
          'border border-[var(--border-strong)] bg-transparent text-[var(--foreground)] hover:bg-[var(--surface-hover)]',
        ghost: 'text-[var(--foreground)] hover:bg-[var(--surface-hover)]',
        danger: 'bg-red-600 text-white hover:bg-red-700',
      },
      size: {
        sm: 'h-8 px-2.5',
        md: 'h-9 px-3',
        // Tablet-first staff surfaces need a 56px target (see `touchTarget` in the design tokens).
        lg: 'h-14 px-6 text-base',
        icon: 'h-9 w-9',
      },
    },
    defaultVariants: { variant: 'default', size: 'md' },
  },
);
